import React from "react";
import { ManageHSNCode } from "../../components/Settings/HsnCode/ManageHSNCode";
import { ToastContainer } from "react-toastify";
export const ManageHSNCodePage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageHSNCode />
        </div>
      </div>
    </div>
  );
};
